import { FormData } from '../types/FormTypes';

export const mockFormData: FormData = {
  title: "About you",
  description: "",
  submitText: "Submit",
  mode: "form",
  showLogo: false,
  fields: [
    {
      name: "Name",
      description: "",
      required: false,
      order: 1,
      field: {
        id: 4920654,
        name: "Name",
        type: "text",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "Instagram",
      description: "",
      required: false,
      order: 2,
      field: {
        id: 4920669,
        name: "Instagram",
        type: "text",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "WhatsApp",
      description: "",
      required: false,
      order: 3,
      field: {
        id: 4920861,
        name: "WhatsApp",
        type: "number",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "Company",
      description: "",
      required: false,
      order: 4,
      field: {
        id: 4920864,
        name: "Company",
        type: "text",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "Started in Real Estate",
      description: "",
      required: false,
      order: 5,
      field: {
        id: 4920869,
        name: "Started in Real Estate",
        type: "date",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "Knowledge and experience",
      description: "",
      required: false,
      order: 6,
      field: {
        id: 4920873,
        name: "Knowledge and experience",
        type: "long_text",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "About me",
      description: "",
      required: false,
      order: 7,
      field: {
        id: 4920874,
        name: "About me",
        type: "long_text",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "E-mail",
      description: "",
      required: false,
      order: 8,
      field: {
        id: 4920878,
        name: "E-mail",
        type: "email",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    },
    {
      name: "Photo",
      description: "",
      required: false,
      order: 9,
      field: {
        id: 4920879,
        name: "Photo",
        type: "file",
        text_default: ""
      },
      show_when_matching_conditions: true,
      condition_type: "AND",
      conditions: [],
      condition_groups: [],
      field_component: "default"
    }
  ],
  values: {}
};